export function sortedBy<T, K>(list: T[], getKey: (item: T) => K, orderedKeys: readonly K[]) {
  const sortedCopy = list.slice();
  sortedCopy.sort((a, b) => {
    let indexA = orderedKeys.indexOf(getKey(a));
    let indexB = orderedKeys.indexOf(getKey(b));
    if (indexA === -1) indexA = Number.POSITIVE_INFINITY;
    if (indexB === -1) indexB = Number.POSITIVE_INFINITY;
    return indexA - indexB;
  });
  return sortedCopy;
}
